import type { ComponentType, SVGProps } from 'react'
import {
  ArrowRight,
  BarChart3,
  Bell,
  Building2,
  CalendarDays,
  CheckSquare,
  ClipboardList,
  ChevronLeft,
  ChevronRight,
  Clock3,
  FileText,
  Handshake,
  HardHat,
  Home,
  LogOut,
  Menu,
  MessageCircle,
  Megaphone,
  MessageSquareWarning,
  KeyRound,
  Languages,
  BellRing,
  RefreshCcw,
  Search,
  Settings2,
  SlidersHorizontal,
  Store,
  ShoppingCart,
  Vote,
  WalletCards,
  Wrench,
  X,
} from 'lucide-react'

type SvgIcon = ComponentType<SVGProps<SVGSVGElement>>

const ICONS = {
  Home,
  Check: CheckSquare,
  Clock: Clock3,
  ArrowRight,
  Bar: BarChart3,
  Building: Building2,
  Handshake,
  HardHat,
  Pin: CalendarDays,
  Store,
  Refresh: RefreshCcw,
  Doc: FileText,
  Voc: MessageCircle,
  Vote,
  Chat: MessageCircle,
  Sliders: SlidersHorizontal,
  Wrench,
  Clipboard: ClipboardList,
  Claim: MessageSquareWarning,
  Notice: Megaphone,
} satisfies Record<string, SvgIcon>

export type IconName = keyof typeof ICONS

export function NavIcon({ name, ...props }: { name: IconName } & SVGProps<SVGSVGElement>) {
  const Icon = ICONS[name]
  return <Icon aria-hidden {...props} />
}

const OMS_ICONS = {
  Home,
  Clipboard: ClipboardList,
  Cart: ShoppingCart,
  Banknote: WalletCards,
  Notice: Megaphone,
  Bell,
  Settings: Settings2,
  Language: Languages,
  BellSettings: BellRing,
  Key: KeyRound,
} satisfies Record<string, SvgIcon>

export type OmsNavIconName = keyof typeof OMS_ICONS

export function OmsNavIcon({ name, ...props }: { name: OmsNavIconName } & SVGProps<SVGSVGElement>) {
  const Icon = OMS_ICONS[name]
  return <Icon aria-hidden {...props} />
}

export const UiIcon = {
  Bell,
  ChevronLeft,
  ChevronRight,
  Close: X,
  LogOut,
  Menu,
  Search,
  Settings: Settings2,
}
